import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "app-helicopters-upload-document-dialog",
    templateUrl: "./helicopters-upload-document-dialog.component.html",
    styleUrl: "./helicopters-upload-document-dialog.component.scss",
    standalone: false,
})
export class HelicoptersUploadDocumentDialogComponent {
    constructor(
        private dialogRef: MatDialogRef<HelicoptersUploadDocumentDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { fileName: string },
    ) {}

    onConfirm() {
        this.dialogRef.close(true);
    }

    onCancel() {
        this.dialogRef.close(false);
    }
}
